<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />
        <div class="my-4">
            <h2>
                Cơ hội kinh doanh
            </h2>
            <hts-data-table
                class="w-full mt-4"
                :headers="headers"
                :items="items || []" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)

const headers = [
  {
    field: '_id',
    headerName: $t('labels.businessOpportunity'),
    valueGetter: (params: any) => {
      const { _id, code } = params.data
      return code || _id
    }
  },
  {
    field: 'positionName',
    headerName: $t('labels.route')
  },
  {
    field: 'customerName',
    headerName: $t('labels.customer')
  },
  {
    field: 'saleName',
    headerName: $t('labels.staffSale')
  },
  {
    field: 'workflowName',
    headerName: $t('labels.workflow')
  },
  {
    field: 'totalQuote',
    headerName: $t('labels.quote'),
    valueGetter: (params: any) => {
      const { totalQuote } = params.data
      return $formatters.formatNumber(totalQuote || 0)
    }
  }
]

const items = ref<any[]>([])

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

onMounted(() => {
  getReport()
})

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    loadReport()
  },
  { deep: true }
)

/** API requests */
const getReport = () => {
  items.value = []
  $api($url.report.getOpportunity, { body: filters.value })
    .then((data: any) => {
      const responseData: any = data.data.value
      if (responseData?.success) {
        items.value = responseData.data
      } else {
        items.value = []
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

const loadReport = $lodash.debounce(getReport, 500)
</script>
